import { render, staticRenderFns } from "./AudioTest.vue?vue&type=template&id=44148012&scoped=true&"
import script from "./AudioTest.vue?vue&type=script&lang=ts&"
export * from "./AudioTest.vue?vue&type=script&lang=ts&"
import style0 from "./AudioTest.vue?vue&type=style&index=0&id=44148012&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44148012",
  null
  
)

export default component.exports